module.exports = __webpack_public_path__ + "static/media/MyTasksOverdue.5882a1aa.svg";